import { render, staticRenderFns } from "./MobileCommunityUnitBusinessNewsDetail.vue?vue&type=template&id=b2be809a&scoped=true&"
import script from "./MobileCommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityUnitBusinessNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityUnitBusinessNewsDetail.vue?vue&type=style&index=0&id=b2be809a&scoped=true&lang=css&"
import style1 from "./MobileCommunityUnitBusinessNewsDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2be809a",
  null
  
)

export default component.exports